import { Badge } from "../components/ui/badge";
import { AlertTriangle, Target, XCircle } from "lucide-react";

function getScoreClass(score) {
  if (score >= 0.8) return "score-high";
  if (score >= 0.6) return "score-medium";
  return "score-low";
}

function getScoreLabel(score) {
  if (score >= 0.8) return "High";
  if (score >= 0.6) return "Medium";
  return "Low";
}

export default function ChunkCard({ chunk, index, hallucinated, attribution }) {
  const score = chunk.score || 0;
  const scorePercent = Math.round(score * 100);
  const attrStatus = attribution?.status;

  return (
    <div 
      className={`chunk-card rounded-sm ${hallucinated ? 'border-red-300 bg-red-50/50' : ''} ${attrStatus === 'noise' ? 'opacity-60' : ''}`}
      data-testid={`chunk-card-${index}`}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-center gap-2">
          <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
            Chunk {index}
          </span>
          {hallucinated && (
            <Badge variant="destructive" className="text-xs gap-1">
              <AlertTriangle className="w-3 h-3" />
              Low Relevance
            </Badge>
          )}
          {attrStatus === "used" && (
            <Badge variant="outline" className="text-[10px] gap-0.5 text-green-700 bg-green-50 border-green-200">
              <Target className="w-3 h-3" />
              Used
            </Badge>
          )}
          {attrStatus === "noise" && (
            <Badge variant="outline" className="text-[10px] gap-0.5 text-red-600 bg-red-50 border-red-200">
              <XCircle className="w-3 h-3" />
              Noise
            </Badge>
          )}
          {attrStatus === "partially_used" && (
            <Badge variant="outline" className="text-[10px] gap-0.5 text-yellow-700 bg-yellow-50 border-yellow-200">
              <Target className="w-3 h-3" />
              Partial
            </Badge>
          )}
        </div>
        <Badge className={`${getScoreClass(score)} border-0 font-mono`}>
          {scorePercent}% - {getScoreLabel(score)}
        </Badge>
      </div>

      {/* Score Bar */}
      <div className="confidence-bar mb-3">
        <div 
          className={`confidence-fill ${score >= 0.8 ? 'bg-green-500' : score >= 0.6 ? 'bg-yellow-500' : 'bg-red-500'}`}
          style={{ width: `${scorePercent}%` }}
        />
      </div>

      {/* Content */}
      <p className="text-sm leading-relaxed line-clamp-4">
        {chunk.content}
      </p>

      {/* Metadata */}
      {chunk.metadata && Object.keys(chunk.metadata).length > 0 && (
        <div className="mt-3 pt-3 border-t border-border">
          <div className="flex flex-wrap gap-2">
            {Object.entries(chunk.metadata).slice(0, 3).map(([key, value]) => (
              <Badge key={key} variant="outline" className="text-xs font-mono">
                {key}: {String(value).slice(0, 20)}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
